/**
 * React Query Configuration Constants
 * Centralized cache time configurations for React Query
 */

/**
 * Default cache time configurations for React Query
 * These values are used across all query hooks for consistent caching behavior
 */
export const QUERY_CACHE_TIME = {
  /** Time data stays fresh before refetch (5 minutes) */
  STALE_TIME: 5 * 60 * 1000,
  /** Time data stays in cache after becoming unused (10 minutes) */
  GC_TIME: 10 * 60 * 1000,
} as const;
